import styled from 'styled-components';
import { slideInLeft } from 'Styles/effects';

export const Wrapper = styled.div.attrs(({ wrapperWidth }) => {
  let width = '55%';
  if (wrapperWidth) width = `${wrapperWidth}px`;
  return ({ style: { width } });
})`
  display: flex;
  flex-direction: row;
  overflow-y: hidden;
  overflow-x: hidden;
  position: absolute;
  right: 0;
  top: 54px;
  z-index: 1;
  box-shadow: -5px 0 12px 0 rgba(35, 35, 35, 0.11);
  height: 100%;
  ${slideInLeft};
`;
Wrapper.displayName = 'Wrapper';

export const Content = styled.div`
  overflow-y: auto;
  padding: 0 20px 20px 0;
  height: 85%;
  & > * {
    margin-bottom: 20px;
  }
  & > :last-child {
    margin-bottom: 0;
  }
`;
Content.displayName = 'Content';
